import { requestGet, requestPost, requestGetCache } from '@/common/request';
import { transformLevelAndHBHLevel } from '@/constants';
import home from './home';
import dataPanel from './data-panel';
import operatePlatform from '@/pages/operate-platform/api';
import promotion from './promotion';
import logout from './logout';
import generic from './generic';
import { findParentItemsList } from '@/common/utils/menu-utils/all-menus';
import * as frontendMenus from '@/constants/frontend-menus';

export * as roomApi from './room';
export * as businessGroundApi from './business-ground';
export * as ruleApi from './rule.js';

// const origin = 'http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a'

export default {
  async findSingleValue(query) {
    return await requestGet('/activityPlan/key', query);
  },
  async jdCloudOssfileupload(query) {
    query.append('module', '1');
    return await requestPost('/jdCloudOss/file/upload', query);
  },
  async fetchActivityDetail(query) {
    const res = await requestGet('/activityPlan/getByVer', query);

    if (res.ret === '0' && res.data) {
      const _result = transformLevelAndHBHLevel(res.data.activityPlan.level, res.data.activityPlan.otherLevel);

      Object.assign(res.data.activityPlan, _result, { treeCompValid: res.data.treeCompValid });
    }

    return res;
    // return await requestGet(origin + '/acore/getActivityDetail', query)
  },
  async fetchResourceDetail(query) {
    return await requestGet('/resource/getResource', query);
  },
  async functionGuideListOnline(query) {
    return await requestGet('/functionGuide/listOnline', query);
  },
  async functionGuideGuide(query) {
    return await requestGet('/functionGuide/guide', query);
  },

  async fetchResource(query, config) {
    return await requestGet('/resource/listSquare', query, config);
    // kreturn await requestGet(origin + '/acore/sources-list', query)
  },
  // 获取全局信息包括用户信息，菜单树，角色信息
  async fetchGlobalInfo() {
    // return await (requestGet(origin + '/acore/globalinfo', query))
    const res = await requestGet('/menu/list', { hasUser: 1, version: 1 }).then((res) => {
      if (res?.data?.roles) {
        res.data.roles = res.data.roles.sort((a, b) => {
          return a.roleId - b.roleId;
        });
      }
      return res;
    });

    if (res.ret !== '0' || !res.data || !res.data.menus) return res;
    // roleRules如果没返回就给他一个空数组
    res.data.roleRules = res.data.roleRules || [];
    //是否需要过滤掉12
    let needRemove = false;
    res.data.menus = res.data.menus.filter((item) => {
      // 活动管理
      if (item.menuId !== 10 /* activityManageFloderId */) return true;

      if (!item.menus) return false;

      // 过滤掉活动管理下审核列表类目，审核列表的ID是12，如果过滤掉12之后为空才会过滤掉当前菜单
      item.menus = item.menus.filter((item) => {
        needRemove = needRemove || item.menuId === 12;
        return item.menuId !== 12;
      });

      // 没有活动管理没有子栏目整个栏目去掉
      return item.menus.length !== 0 || !needRemove;
    });

    if (res.data.roleRules?.length > 0) {
      res.data.menus = res.data.menus.concat(findParentItemsList(res.data.menus), [
        {
          menuId: 46,
          menus: [],
          title: '营销词阵地',
        },
      ]);
    }

    res.data.menus = frontendMenus.injectMenus(res.data.menus);

    res.data.menus = [
      ...res.data.menus,
      {
        menuId: -100,
        createTime: 1645587606000,
        menuName: '工具箱',
        menus: [],
        parentId: -1,
        status: 1,
        updateTime: 1645587606000,
      },
    ];

    return res;
  },
  async validateErp(erps) {
    // return await requestGet(origin + '/acore/pin/vaild', { erps })
    return await requestGet('/pin/valid', { erps });
  },

  // oss文件上传接口
  async fileUpload(query) {
    return await requestPost('/oss/file/upload', query);
  },

  async fetchGetActivityDetail(query) {
    return this.fetchActivityDetail(query);
  },
  // 货币化pin接口
  async fetchmonetisePin(query) {
    return await requestGet('/resource/monetisePin', query);
  },

  async fetchResourceApply(query) {
    return await requestGet('/resource/applyResource', query);
  },

  // banner管理 - 跳转链接校验
  async bannerJumpUrlValidate(query) {
    return await requestGet('/banner/jumpUrlValidate', query);
  },

  async fetchCategories(query = {}) {
    return await requestGet('/cate/list', query);
    // return await requestGet('http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/getCategory', query)
  },

  async queryOrganization(code) {
    // return await requestGet('http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/organization/queryChildOrganization', { parentOrganizationCode: code })
    return await requestGet('/organization/queryChildOrganization', { parentOrganizationCode: code });
  },

  async createActivity(data) {
    return await requestPost('/activityPlan/addActivityPlan', data);
    // return await requestPost('http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/activityPlan/updateActivityPlan', data)
  },

  async updateActivity(data) {
    return await requestPost('/activityPlan/updateActivityPlan', data);
    // return await requestPost('http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/activityPlan/updateActivityPlan', data)
  },

  // 创建频道活动
  async channelActivityAdd(query) {
    return await requestPost('/channelActivity/add', query);
  },
  // 活动接口
  async queryActivityPlanDataAll(data) {
    return await requestGet('/queryActivityPlan', data);
  },

  // 获取一级部门
  async queryDepartment(query = {}) {
    return await requestGet('/queryDepartment', query);
    // return await requestGet('/queryDepartment', query)
  },

  async queryActivityInfo(query = {}) {
    // return await requestGet('/cate/list', query)
    return await requestGet('/queryActivityInfo', query);
  },

  async queryUserPortrait(data) {
    return await requestGet('/queryUserPortrait', data);
  },

  async queryPlatformData(query = {}) {
    // return await requestGet('/cate/list', query)
    return await requestGet('/queryPlatformData', query);
  },
  // 活动会场数据
  async activitySquareData(data) {
    const res = await requestGet('/activitySquareData', data);

    if (!res || res.ret !== '0' || !res.data || !res.data.list) return res;

    res.data.list = res.data.list.map((item) => {
      if (item.dataAuth) return item;
      return {
        towerId: item.towerId,
        squareName: item.squareName,
      };
    });

    return res;
  },

  // 活动会场分时数据
  async activityTimeData(data) {
    // return await requestGet('http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a/acore/activityTimeData', data)
    return await requestGet('/activityRoomDetail', data);
  },

  // 活动会场分楼层素材数据
  async activitySourceData(data) {
    return await requestGet('/activityRoomMaterial', data);
  },

  async activityVsActivity(query) {
    return await requestGet('/activityCompare', query);
  },

  async getActivityDetailByApplicationId(query) {
    return await requestGet('/resource/examineDetail', query);
  },

  async assignResource(query) {
    return await requestGet('/resource/directApplyResource', query);
  },

  async checkActivityName(activityName) {
    return await requestGet('/activityPlan/check', { activityName });
  },

  async fetchProductData(query) {
    return await requestGet('/queryProductInfo', query);
  },

  async fetchProductDataRoom(query) {
    return await requestGet('/queryProductDetail', query);
  },

  async fetchProductDataByDay(query) {
    return await requestGet('/fetchProductDataByDay', query);
  },

  async listOwnResourceState(query) {
    return await requestGet('/resource/listOwnResourceState', query);
  },
  // 资源列表查询接口
  async listCmsResource(query) {
    return await requestGet('/cmsResource/listCmsResource', query);
  },
  // 删除资源接口
  async deleteResource(query) {
    return await requestGet('/cmsResource/delete', query);
  },

  async checkResource(query) {
    return await requestGet('/cmsResource/checkResource', query);
  },

  async addResource(query) {
    return await requestPost('/cmsResource/addResource', query);
  },

  async editResource(query) {
    return await requestPost('/cmsResource/updateResource', query);
  },

  // 根据资源ID查询资源详情接口
  async getCmsResourceInfo(query) {
    return await requestGet('/cmsResource/getCmsResource', query);
  },

  async uploadPic(query) {
    return await requestPost('/file/uploadFile', query);
  },

  async resourceList() {
    return await requestGet('/resource/list', { pageSize: 1000 });
  },
  // 查询商品池信息接口
  async getCommodityPoolInfo(query) {
    return await requestGet('/commodityPool/info', query);
  },
  // 获取打标信息
  async getTagInfo(query) {
    return await requestGet('/tag/info', query);
  },
  // 氛围标签-打标功能
  async doTag(query) {
    return await requestGet('/tag/doTag', query);
  },
  // 氛围标签-校验标签
  // async checkTag (query) {
  //   return await requestGet('/tag/checkTag', query)
  // },

  home,
  // commodityPool/mainGoods
  async mainGoods(query) {
    return await requestGet('/commodityPool/mainGoods', query);
  },
  // 会场模块-会场楼层
  async actRoomFloorList(query) {
    return await requestGet('/actRoom/floorList', query);
  },
  // 会场模块-会场楼层Header
  async actRoomFloorHeader(query) {
    return await requestGet('/actRoom/roomHeader', query);
  },

  // 实时数据-活动数据
  async queryRealActivityPlanDataAll(data) {
    return await requestGet('/queryRealTimeActivityPlan', data);
  },
  // 实时数据-活动会场数据
  async realActivitySquareData(data) {
    const res = await requestGet('/activityRealTimeSquareData', data);

    if (!res || res.ret !== '0' || !res.data || !res.data.list) return res;

    res.data.list = res.data.list.map((item) => {
      if (item.dataAuth) return item;
      return {
        towerId: item.towerId,
        squareName: item.squareName,
      };
    });

    return res;
  },
  // 实时数据-活动会场分时数据
  async realActivityTimeData(data) {
    // return await requestGet('http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a/acore/activityTimeData', data)
    return await requestGet('/activityRealTimeRoomDetail', data);
  },
  // 实时数据活动会场分楼层素材数据
  async realActivitySourceData(data) {
    return await requestGet('/activityRealTimeRoomMaterial', data);
  },
  // 底池管理主推商品导出
  async mainGoodsExport(data) {
    return await requestGet('/commodityPool/mainGoodsExport', data);
  },
  // 活动商品池详情
  async getGoodsPoolInfo(data) {
    return await requestGet('/goodsPool/info', data);
  },
  // 活动商品池列表
  async getGoodsPoolList(data) {
    return await requestGet('/goodsPool/list', data);
  },
  // 创建活动商品池
  async createPool(data) {
    return await requestGet('/goodsPool/create', data);
  },
  // 导出活动商品池数据 规则选品
  async exportPool(data) {
    return await requestGet('/goodsPool/export', data);
  },

  dataPanel,
  operatePlatform,
  // 是否强提醒弹窗
  async feedbackIsShow(data) {
    return await requestGet('/feedback/isShowWindow', data);
  },
  // 评分信息上报
  // 接口文档：https://cf.jd.com/pages/viewpage.action?pageId=418652799
  async feedbackSubmit(data) {
    return await requestPost('/feedback/submit', data);
  },

  // 满意度调研 - 获取列表
  async questionnaireList(data) {
    return await requestGet('/questionnaire/list', data);
  },

  async reportSave(data) {
    return await requestPost('/report/save', data);
  },

  async statisticTree(query, level, isJoin) {
    const data = await requestGetCache('/statistic/tree', query);
    return {
      ...data,
      data: processData(data.data, level, isJoin),
    };
  },

  // 素材底池 - 已分配资源列表
  async materialPoolMemberList(query) {
    return await requestGet('/materialPool/member/list', query);
  },
  // 素材底池 - 删除分配权限
  async materialPoolRemoveMember(query) {
    return await requestGet('/materialPool/removeMember', query);
  },
  // 素材底池 - 分配资源
  async materialPoolMemberAdd(data) {
    return await requestGet('/materialPool/member/add', data);
  },
  async marketOrgSearch(data) {
    return await requestGet('/market/org/search', data);
  },

  async materialPoolSpecCates(data) {
    return await requestGet('/materialPool/specCates', data);
  },
  //招选商品列表查询
  async getMerchantsList(data) {
    return await requestPost('/generic/merchantsListService/getMerchantsList ', data);
  },
  //下载招选列表
  async downloadMerchantsList(data) {
    return await requestPost('/generic/merchantsListService/downloadMerchantsList', data);
  },
  //部门查询
  async monitorTree(data) {
    return await requestGet('/monitor/tree ', data);
  },
  //商品池
  async monitorGoodsPool(data) {
    return await requestGet('/monitor/goodsPool ', data);
  },
  //明细列表
  async getMerchantsDetailList(data) {
    return await requestPost('/generic/merchantsListService/getMerchantsDetailList', data);
  },

  async queryUserRooms(data) {
    return await requestGet('/room/queryUserRoomList', data);
  },
  //会场总数查询
  async getFieldCount(data) {
    return await requestPost('/generic/marketingCenterService/getFieldNum', data);
  },
  //楼层概览图表查询
  async getFloorSummaryData(data) {
    return await requestPost('/generic/marketingCenterService/getGraphData', data);
  },
  //会场明细查询
  async getFieldTableData(data) {
    return await requestPost('/generic/marketingCenterService/getTableData', data);
  },
  //会场明细下载
  async downloadFieldTableData(data) {
    return await requestPost('/generic/marketingCenterService/tableDownload', data);
  },
  //用户资产沉淀数据
  async getUserAssetPrecipitationData(data) {
    return await requestPost('/generic/userAssetPrecipitationService/getUserAssetPrecipitationData', data);
  },
  //商品分析
  async getDataOverview(data) {
    return await requestPost('/generic/goodsAnalysisService/getDataOverview', data);
  },
  //商品分析下载数据
  async downloadGoodsList(data) {
    return await requestPost('/generic/goodsAnalysisService/downloadGoodsList', data);
  },
  //分时天数据
  async getTimeOrDayData(data) {
    return await requestPost('/generic/goodsAnalysisService/getTimeOrDayData', data);
  },
  //多维分析
  async getMultiLevelDepartAndBusinessModel(data) {
    return await requestPost('/generic/goodsAnalysisService/getMultiLevelDepartAndBusinessModel', data);
  },
  //会场分析-分时天数据
  async getHourDetailList(data) {
    return await requestPost('/generic/activityListService/getHourDetailList', data);
  },
  //会场分析-详情数据查询
  async getRoomDetailList(data) {
    return await requestPost('/generic/activityListService/getDetailList', data);
  },

  //会场分析-总览查询
  async getActivityTotalInfo(data) {
    return await requestPost('/generic/activityListService/getActivityTotalInfo', data);
  },

  //会场分析下载数据
  async downloadActivityList(data) {
    return await requestPost('/generic/activityListService/downloadActivityList', data);
  },
  //营销阵地 - 阵地列表
  async platformList(data) {
    return await requestGet('/platform/list', data);
  },
  //综促模块 - 获取我的综促活动列表优惠券场景下
  async zongcuCouponRelationList(data) {
    return await requestGet('/zongcu/couponRelationList', data);
  },
  //综促模块 - 校验id
  async zongcuMacActIdValidate(data) {
    return await requestGet('/zongcu/macActIdValidate', data);
  },
  //综促模块 - 列表接口
  async getUMInfo(data) {
    return await requestPost('/generic/unitedMarkingService/getUMInfo', data);
  },

  //综促模块 - 下载接口
  async downloadUMInfo(data) {
    return await requestPost('/generic/unitedMarkingService/downloadComplexList', data);
  },
  //综促模块 - 获取我的综促活动列表优惠券场景下
  async zongcuCouponRelationList(data) {
    return await requestGet('/zongcu/couponRelationList', data);
  },
  //综促模块 - 校验id
  async zongcuMacActIdValidate(data) {
    return await requestGet('/zongcu/macActIdValidate', data);
  },
  //综促模块 - 列表接口
  async getUMInfo(data) {
    return await requestPost('/generic/unitedMarkingService/getUMInfo', data);
  },

  //综促模块 - 下载接口
  async downloadUMInfo(data) {
    return await requestPost('/generic/unitedMarkingService/downloadComplexList', data);
  },
  async activityPlanDiffsetSave(data) {
    return await requestPost('/activityPlan/diffset/save', data);
  },
  async activityPlanDiffsetGet(data) {
    return await requestPost('/activityPlan/diffset/get', data);
  },

  promotion,
  logout,
  generic,
};

function processData(data, level = 3, isJoin = false) {
  const result = data.concat();
  level === 2 &&
    result.forEach((item) => {
      item.children.forEach((items) => {
        delete items.children;
        if (isJoin) {
          if (items.value.split('-').length > 1) return;
          items.value = item.value + '-' + items.value;
          items.key = item.key + '-' + items.key;
        }
      });
    });
  return result;
}
